// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.129}
      d="M12.4712 9.92832V11.6317C12.4719 11.7899 12.4395 11.9464 12.3761 12.0913C12.3128 12.2362 12.2199 12.3662 12.1033 12.4731C11.9868 12.58 11.8492 12.6614 11.6994 12.7121C11.5496 12.7627 11.3909 12.7816 11.2334 12.7673C9.48619 12.5775 7.80786 11.9804 6.33328 11.0242C4.96137 10.1524 3.79824 8.98928 2.92647 7.61737C1.96687 6.13609 1.3697 4.4496 1.18332 2.69453C1.16913 2.53751 1.18779 2.37926 1.23811 2.22985C1.28843 2.08044 1.36931 1.94315 1.4756 1.82671C1.58189 1.71027 1.71126 1.61724 1.85548 1.55354C1.99969 1.48984 2.15559 1.45687 2.31325 1.45672H4.01665C4.29221 1.45401 4.55935 1.55159 4.76828 1.73127C4.97722 1.91095 5.11369 2.16048 5.15225 2.43334C5.22415 2.97847 5.35749 3.51371 5.54972 4.02886C5.62611 4.23209 5.64264 4.45296 5.59736 4.6653C5.55207 4.87764 5.44687 5.07254 5.2942 5.22692L4.5731 5.94803C5.38139 7.36955 6.55839 8.54654 7.97991 9.35484L8.70101 8.63373C8.85539 8.48107 9.0503 8.37587 9.26264 8.33058C9.47498 8.2853 9.69585 8.30183 9.89908 8.37822C10.4142 8.57045 10.9495 8.70379 11.4946 8.77568C11.7704 8.8146 12.0223 8.95352 12.2024 9.16604C12.3825 9.37857 12.4781 9.64986 12.4712 9.92832Z"
    />
  </svg>
);
const IconPhone = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconPhone;
